// DS: i1.2
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
const Core = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M12.328 22.108a9.662 9.662 0 003.9-.792 10.178 10.178 0 003.168-2.141 9.848 9.848 0 002.17-3.197 9.907 9.907 0 00.762-3.87 9.982 9.982 0 00-.762-3.9 9.934 9.934 0 00-2.17-3.168 9.933 9.933 0 00-3.168-2.17 9.661 9.661 0 00-3.9-.792 9.662 9.662 0 00-3.9.792A10.283 10.283 0 005.23 5.04c-.899.9-1.613 1.955-2.14 3.167a9.982 9.982 0 00-.763 3.9c0 1.369.254 2.66.763 3.871a10.086 10.086 0 002.14 3.197c.92.9 1.985 1.613 3.197 2.14a9.663 9.663 0 003.9.793zm1.437-16.335L14 5.54h2.404v2.375L14 12.518l.176.235h2.228v3.284h-4.046l-.353.235-1.114 2.14-.234.264H8.252v-2.404l2.405-4.604-.176-.235H8.25V8.149H12.3l.352-.235 1.114-2.14z"
    })));
};
Core.displayName = 'Core';
export default Core;
